import { packagesPostBookingApi } from "./api";

export const packagesPostBookingReducers = {
  [packagesPostBookingApi.reducerPath]: packagesPostBookingApi.reducer,
};

export const packagesPostBookingApiMiddlewares = [
  packagesPostBookingApi.middleware,
];

export { packagesPostBookingApi };
